jQuery(function($){
	$('.section-group .section-group-item .title-bar').on('click', function(e){
		if($(this).closest('.section-group-item').hasClass('do-not-expand')) return;

		if($(e.target).is('a')) return;

		expandListItem($(this));
	});

	$('.section-group .section-group-item .title-bar .detail-expand-link').on('click', function(e){
		e.preventDefault();

		expandListItem($(this).closest('.title-bar'));
	});

	function expandListItem(el) {
		let windowTop = $(window).scrollTop();

		let offsetTop = el.offset().top;

		let currentSectionGroupItem = el.closest('.section-group-item');
		let wasExpanded = currentSectionGroupItem.hasClass('expanded');

		let expandedWindows = $('.section-group-item.expanded');
		let expandedWindowOffset = 0;
		$(expandedWindows).each(function(index){
			$(expandedWindows[index]).find('.expand-window').each(function(){
				if($(this).offset().top < offsetTop) expandedWindowOffset += $(this).height();
			});
		});

		let scrollTop = offsetTop - getSnapOffset(expandedWindowOffset, windowTop);

		$('.section-group-item').each(function(){
			$(this).removeClass('expanded');
		});

		if(wasExpanded) {
			currentSectionGroupItem.removeClass('expanded');
		} else {
			$(window).scrollTop(scrollTop);
			setTimeout(function(){
				$(window).scrollTop(scrollTop);
			}, 500);
			currentSectionGroupItem.addClass('expanded');
			let ajaxDetails = currentSectionGroupItem.find('.before-expand-details-ajax');
			if(currentSectionGroupItem.length > 0) {
				$.each(ajaxDetails, function(index, div){
					loadAjaxDetails(div);
				});
			}
		}		
	}

	function getSnapOffset(expandedWindowOffset, windowTop) {
		let adminBarOffset = 0;
		if($('#wpadminbar').length > 0) adminBarOffset += $('#wpadminbar').height();

		let elements = $('*').filter(function() { 
				return $(this).css('position') == 'fixed' || $(this).css('position') == 'sticky';
		});

		let validElements = [];
		$(elements).each(function(index){
			let atTop = $(elements[index]).offset().top == windowTop + adminBarOffset;
			let leftAtMenu = $(elements[index]).offset().left == $('body').offset().left;

			if(leftAtMenu && (atTop || $(elements[index]).attr('id') == 'masthead')) {
				validElements.push(elements[index]);
			}
		});

		let snapOffset = 0;
		snapOffset += adminBarOffset;
		$(validElements).each(function(index){
			snapOffset += $(validElements[index]).outerHeight();
		});

		snapOffset += expandedWindowOffset;

		return snapOffset;
	}

	$('body.single .before-expand-details-ajax').each(function(){
		loadAjaxDetails(this);
	});

	$(document).on('click', '.detail.image-description.has-image.expanded .detail-expand-background', function(e){
		$(this).closest('.detail').removeClass('expanded');
		e.stopPropagation();
	});

	$(document).on('click', '.detail.image-description.has-image', function(){
		if(!$(this).hasClass('expanded')) $(this).addClass('expanded');
	});

	loadAttendanceCharts(false);

	function loadAjaxDetails(div) {
		if(!$(div).hasClass('loaded')) {

			let data = {
				action: 'choralorg_ajax_before_expand_details',
				module: $(div).attr('module'),
				post: $(div).attr('post')
			};

			$(div).html('<div class="ajax-content-loading"><div class="loader"><div></div><div></div></div> Loading details...</div>');

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				$(div).html(response).addClass('loaded');
				if(response === null || response.match(/^\s*$/) !== null) $(div).hide(); //Hide if blank
				loadAttendanceCharts(true);
			});
		}		
	}

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		let name = cname + "=";
		let ca = document.cookie.split(';');
		for(let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	// function checkCookie() {
	//   let user = getCookie("username");
	//   if (user != "") {
	//     alert("Welcome again " + user);
	//   } else {
	//     user = prompt("Please enter your name:", "");
	//     if (user != "" && user != null) {
	//       setCookie("username", user, 365);
	//     }
	//   }
	// }

	$('.choralorg-member-menu-wrapper .expand-member-menu').on('click', function(){
		$('body').toggleClass('co-member-menu-collapsed');
		let isMenuCollapsed = ($('body').hasClass('co-member-menu-collapsed'));
		console.log(isMenuCollapsed);
		setTimeout(function(){
			document.dispatchEvent(new Event('sidebarToggled'));
		}, 50);
		setTimeout(function(){
			setCookie('isMemberMenuCollapsed', isMenuCollapsed, 7);
			console.log(getCookie('isMemberMenuCollapsed'));
			windowDimensions = {
				width: window.innerWidth,
				height: window.innerHeight
			};
		}, 500);
	});

	let windowDimensions = {
		width: window.innerWidth,
		height: window.innerHeight
	};

	function autoCollapseMenu(onLoad = false) {
		setTimeout(function(){
			if(onLoad || window.innerWidth != windowDimensions.width) {
				windowDimensions = {
					width: window.innerWidth,
					height: window.innerHeight
				};

				let widthTest = window.innerWidth;

				const menuCookie = getCookie('isMemberMenuCollapsed');
				if(menuCookie.length) {
					if(menuCookie == 'true') {
						$('body').addClass('co-member-menu-collapsed');
					} else {
						$('body').removeClass('co-member-menu-collapsed');
					}
				} else {
					if(widthTest <= 600) {
						$('body').addClass('co-member-menu-collapsed');
					} else {
						$('body').removeClass('co-member-menu-collapsed');
					}
				}
			}
		}, 500);
	}
	autoCollapseMenu(true);

	$(window).on('resize', autoCollapseMenu);

	function loadAttendanceCharts(postCall) {
		if($('.attendance-percentage-chart').length > 0) {
			$('.attendance-percentage-chart').each(function(){
				var chartId = $(this).attr('chart-id');
				var chartColor = $(this).attr('chart-color');
				var chartValid = parseInt($(this).attr('chart-valid'));
				var chartTotal = parseInt($(this).attr('chart-total'));
				var chartMissed = chartTotal - chartValid;
				var data = [chartMissed, chartValid];

				if(!Chart.getChart(chartId)) {
					new Chart(chartId, {
						type: 'doughnut',
						data: {
							datasets: [{
								label: 'Present',
								data: data,
								backgroundColor: [
									'transparent',
									chartColor
								],
								hoverBackgroundColor: [
									'transparent',
									chartColor
								],
								borderWidth: 0
							}]
						},
						options: {
							responsive: false,
							cutout: '85%',
							animations: {
								startAngle: {
									from: Math.PI * 2
								},
								endAngle: {
									from: Math.PI * 2
								}
							},
							plugins: {
								tooltip: {
									enabled: false
								},
							}
						},
						plugins: [{
							afterUpdate: function(chart) {
								const arcs = chart.getDatasetMeta(0).data;

								arcs.forEach(function(arc) {
									arc.round = {
										x: (chart.chartArea.left + chart.chartArea.right) / 2,
										y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
										radius: (arc.outerRadius + arc.innerRadius) / 2,
										thickness: (arc.outerRadius - arc.innerRadius) / 2,
										backgroundColor: arc.options.backgroundColor
									}
								});
							},
							afterDraw: function(chart){
								const {ctx, canvas} = chart;

									chart.getDatasetMeta(0).data.forEach(arc => {
									const angles = [
										Math.PI / 2 - arc.startAngle,
										Math.PI / 2 - arc.endAngle
									];


									ctx.save();
									ctx.translate(arc.round.x, arc.round.y);
									ctx.fillStyle = arc.options.backgroundColor;
									ctx.beginPath();

									$.each(angles, function(index,value) {
											ctx.arc(arc.round.radius * Math.sin(value), arc.round.radius * Math.cos(value), arc.round.thickness * .925, 0, 2 * Math.PI);
									});

									ctx.closePath();
									ctx.fill();

									ctx.restore();
								});
							}
						}]
					});
				}
			});
		}
	}
});